export default __webpack_public_path__ + "static/media/control-room.7127b8d5.png";